import React, { useEffect } from "react";
import { connect } from "react-redux";
import { callGetExistingTravels, callCancelExistingTravel } from "../../../actions/cardControls.actions";
import Show from "../../../utils/show.component";
import { CardControlsRestartButton } from "../misc/card-controls-restart-button.component";
import { Col, Row } from "react-bootstrap";
import { popupMenuOptions } from "../parent/data/popupMenuOptions";

const ExistingTravelSelectionComponent = (props) => {  
  useEffect(() => {
    props.callGetExistingTravels();
  }, []);

  useEffect(() => {
    // if there are no existing travels, then this step is not required
    if (props.existingTravelsLoaded && props.existingTravels.length == 0) {
      props.advanceToNextStep();
    }
  }, [props.existingTravels]);

  const cancelTravel = (travel) => {
    props.showCardControlsModal(
      true,
      popupMenuOptions.valid.CancelExistingTravelExemption,
      props.cardInfo.agreeNbr,
      props.cardInfo.cardType,
      props.IsActive,
      props.CardNumberLastFour,
      props.callCancelExistingTravel,
      travel,
      props.advanceToCompleteStep
    );
  }

  return (
    <div className="m-auto text-center" style={{maxWidth: "570px"}}>
      <h2 className="bolder my-5">Existing Exemptions</h2>
      {props.existingTravels.map((travel) => {
        return (
          <div className="mb-4 existing-travel-container">
            <div style={{ fontWeight: "600", margin: "20px "}}>{travel.TravelDuration}</div>
            <hr />
            <Row className="mb-2">
              <Col xs={4} className="existing-travel-label">Card</Col>
              <Col xs={8} className="existing-travel-value">{travel.CardDetails.MaskedCardNumber}</Col>
            </Row>
            <Row className="mb-2">
              <Col xs={4} className="existing-travel-label">Cardholder</Col>
              <Col xs={8} className="existing-travel-value">{props.cardInfo.cardHoldersName}</Col>
            </Row>
            <Row className="mb-2">
              <Col xs={4} className="existing-travel-label">Countries</Col>
              <Col xs={8} className="existing-travel-value">{travel.TravelExemptionCountries.map(e=>e.Name).join(", ")}</Col>
            </Row>
            <Row className="mb-2">
              <Col xs={6}>
                  <button
                  className="mt-5 button primary full"
                  onClick={() => props.editTravel(travel)}
                >
                  Edit
                </button>              
              </Col>
              <Col xs={6}>
                  <button
                  className="mt-5 button full cancel-existing-travel-with-border"
                  onClick={() => cancelTravel(travel)}
                >
                  Cancel
                </button>              
              </Col>
            </Row>
          </div>
        );
      })}
      <div style={{ padding: "0rem 4rem" }}>
        <Show condition={props.existingTravels.length === 1}>
          <button
            className="button primary full"
            onClick={() => props.showTravelReasonSelectionModal()}>
            Add a New Exemption
          </button>
        </Show>
        <CardControlsRestartButton backToCards={props.backToCards} buttonText="Cancel" />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => state;

const mapDispatchToProps = {
  callGetExistingTravels,
  callCancelExistingTravel
};
const ExistingTravelSelection = connect(mapStateToProps, mapDispatchToProps)(ExistingTravelSelectionComponent);

export default ExistingTravelSelection;



// WEBPACK FOOTER //
// ./src/components/card-controls/flow-components/existing-travel-selection.component.js